// Third Party Imports
import React from 'react';

// HA Artifactory Imports
import FormSelect from '@homeaway/react-form-select';

// Relative Imports
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import AlertBox from '../Alert/Alert';
import './BankingLocation.less';
import getCurrencySymbol from '../utils/currencyUtil';
import {SVGIcon} from '@homeaway/react-svg';
import lightbulbIcon from '../../images/lightbulb-icon';

class BankingLocation extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }


    getCurrencyListItems = (currencyList) => {
        const {translations} = this.props;
        const items = currencyList && currencyList.length > 0 ?
            currencyList.map((e) => ({
                label: `${getCurrencySymbol(e)} (${translations[`ipmob.currency.${e}`] ? translations[`ipmob.currency.${e}`] : e})`,
                value: e
            })) :
            [];
        items.unshift('');
        return items;
    }

    getBankingCountryListItems = (bankingCountryList) => {
        const {translations} = this.props;
        const items = bankingCountryList && bankingCountryList.length > 0 ?
            bankingCountryList.map((e) => ({
                label: translations[`ipmob.banking_location.country.${e.countryCode}`],
                value: e.countryCode
            })) : [];
        items.unshift('');
        return items;
    }

    renderCurrencyComponent = (currencyList) => {
        const {currency, translations, handleCurrencyChange, handleCurrencyOnBlur, currencyError} = this.props;
        const currencyHead = currencyList.length === 1? translations['ipmob.banking_location.sub_heading_3']: translations['ipmob.banking_location.sub_heading_2'];
        return (<div>
                    <div className="wrapper">
                        <div className="content-col-text sub-head">
                            <h3>{currencyHead}</h3>
                        </div>
                    </div>

                    <div className="wrapper">
                        <div className="content-col">
                            {currencyList.length === 1
                                ? <div className="currency-desc">
                                    {`${getCurrencySymbol(currencyList[0])} (${translations[`ipmob.currency.${currencyList[0]}`] ? translations[`ipmob.currency.${currencyList[0]}`] : currencyList[0]})`}
                                </div>
                                : <FormSelect
                                        id="currencySelection"
                                        name="Currency selected"
                                        items={this.getCurrencyListItems(currencyList)}
                                        label={translations['ipmob.currency']}
                                        value={currency}
                                        onChange={handleCurrencyChange}
                                        errorMsg={translations[currencyError]}
                                        onBlur={handleCurrencyOnBlur}
                                  />
                            }
                        </div>
                    </div>
               </div>)
    }




    render() {
        const {
            translations,

            bankingCountryList,
            bankingCountryCode,
            bankingCountryCodeError,
            handleBankingCountryChange,
            handleBankingCountryOnBlur,


            currencyList,

            serviceError,
            handleAlertDismiss,
            enableContinueButton,
            enableBackButton,
            handleFormSubmit,
            handleBackButtonClick,
        } = this.props;

        return (
            <div id="bankingLocation" className="banking-location">
                <div className="banking-location-container">
                        <div className="form-col">
                            {(serviceError) ? (
                                <div className="alert-panel">
                                    <AlertBox
                                        messageKey={serviceError}
                                        translations={translations}
                                        handleAlertDismiss={handleAlertDismiss}
                                        size={'sm'}
                                    />
                                </div>
                            ) : null}

                            <div className="wrapper">
                                <div className="content-col-text panel-head">
                                    <h1 className="head">{translations['ipmob.banking_location.heading_1']}</h1>
                                </div>
                            </div>
                            <div className="wrapper">
                                <div className="content-col-text">
                                    <div className="desc">{translations['ipmob.banking_location.heading_1.desc']}</div>
                                </div>
                            </div>
                            <form role="form" onSubmit={handleFormSubmit}>
                                <div className="input-container" aria-label="Big form">
                                    <div className="wrapper">
                                        <div className="content-col-text sub-head">
                                            <h3>{translations['ipmob.banking_location.sub_heading_1']}</h3>
                                        </div>
                                    </div>
                                    <div className="wrapper">
                                        <div className="content-col">
                                            <FormSelect
                                                id="bankingCountry"
                                                name="Banking Country selected"
                                                items={this.getBankingCountryListItems(bankingCountryList)}
                                                label={translations['ipmob.mailing_address.label_1']}
                                                value={bankingCountryCode}
                                                onChange={handleBankingCountryChange}
                                                errorMsg={translations[bankingCountryCodeError]}
                                                onBlur={handleBankingCountryOnBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="wrapper">
                                        <div className="content-col-text">
                                            <div className="desc">{translations['ipmob.banking_location.sub_heading_1.desc']}</div>
                                        </div>
                                    </div>
                                </div>
                                {currencyList && currencyList.length > 0
                                    ? this.renderCurrencyComponent(currencyList)
                                    : null
                                }
                                <ContinueButtonHolder
                                    enableContinueButton={enableContinueButton}
                                    handleContinueButtonClick={handleFormSubmit}
                                    translations={translations}
                                    enableBackButton={enableBackButton}
                                    handleBackButtonClick={handleBackButtonClick}
                                    continueButtonId={'bankingLocationContinueBtn'}
                                />
                            </form>
                        </div>
                        <div className="content-col info-card-col">
                            <div className="card info-card">
                                    <div className="content-col-text">
                                        <div className={"lightbulb-icon-holder"}><SVGIcon className="lightbulb-icon" markup={lightbulbIcon}/></div>
                                        <div className="sub-head">{translations['ipmob.banking_location.info.heading_1']}</div>
                                        <div className="desc">{translations['ipmob.banking_location.info.heading_1.desc']}</div>
                                    </div>
                            </div>
                        </div>
                </div>
            </div>
        );
    }
}

export default BankingLocation;
